import { NO_END, NO_START } from '@ha/date';
import { DATE_RANGE_FORMAT } from 'ha/constants/Dates';
import { useIntl } from 'ha/i18n';

export const useGetAvailabilityText = (period: {
  to?: string;
  from?: string;
}) => {
  const { formatDate } = useIntl();
  let blockedPeriodText: string;
  if (period.to === NO_END) {
    blockedPeriodText = formatDate(DATE_RANGE_FORMAT, period.from);
  } else if (period.from === NO_START) {
    blockedPeriodText = `${formatDate(
      DATE_RANGE_FORMAT,
      new Date().toISOString(),
    )} - ${formatDate(DATE_RANGE_FORMAT, period.to)}`;
  } else {
    blockedPeriodText = `${formatDate(
      DATE_RANGE_FORMAT,
      period.from,
    )} - ${formatDate(DATE_RANGE_FORMAT, period.to)}`;
  }
  return blockedPeriodText;
};
